import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seoHead";
import { PrivateRoute } from "@/components/auth/PrivateRoute";
import CompletarPerfil from "@/pages/CompletarPerfil";

export const Route = createFileRoute("/completar-perfil")({
  head: () => seoHead({
    title: "Completar perfil | Shopping do Bem",
    description: "Complete seu perfil para começar a doar comprando.",
    path: "/completar-perfil",
    noindex: true,
  }),
  component: () => (
    <PrivateRoute>
      <CompletarPerfil />
    </PrivateRoute>
  ),
});
